import React, { FC } from 'react';
import { Pill } from '@clearcover/atlas';
import { Table, TableProps } from 'Shared/components';
import { AttributionPolicyType } from 'Admin/services/endpoints/PostAttributionSearch';
import { POLICY_STATUS_COLOR_MAP } from 'Policies/utils';
import { useStore } from '../../store';

import styles from './styles.module.css';

type PoliciesTableProps = TableProps;

export const buildPolicyListRow = (
  row: AttributionPolicyType,
  checkboxSelected: boolean
) => {
  return {
    key: row.universalPolicyId,
    checkboxSelected: checkboxSelected,
    data: [
      row.policyNumber,
      <Pill
        variant={
          row.displayStatus
            ? POLICY_STATUS_COLOR_MAP[row.displayStatus]
            : 'disabled'
        }
        title={row.displayStatus || ''}
        className={styles.policyStatus}
      >
        {row.displayStatus}
      </Pill>,
      row.policyEffectiveState,
      row.attributedPartnerName,
      row.attributedPortalUserName,
      row.attributedPortalUserEmail,
    ],
    onViewRow: () => {
      // Open in a new window/tab so that we don't lose reattribution state
      window.open(
        `${window.location.origin}/policies/${row.externalPolicyId}`,
        '_blank'
      );
    },
  };
};

export const PoliciesTable: FC<PoliciesTableProps> = ({
  name,
  rows,
  onCheckboxSelect,
  onCheckboxSelectAll,
  checkboxSelection = true,
  ...props
}) => {
  const [state] = useStore();
  return (
    <Table
      {...props}
      checkboxSelection={checkboxSelection}
      loading={state.policies.loading}
      name={name}
      columnWidths={[1, '200px', '100px', 2, 2, 2]}
      headers={[
        'Policy',
        'Status',
        'State',
        'Agency Name',
        'Agent Name',
        'Agent Email',
      ]}
      rows={rows}
      onCheckboxSelect={onCheckboxSelect}
      onCheckboxSelectAll={onCheckboxSelectAll}
    />
  );
};
